module.exports = __webpack_public_path__ + "static/media/brainstorming.eb9adb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/brainstorming.png
// module id = 179
// module chunks = 0